import api from './api';

const resource = 'ImageLibrary/';

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

export const folders = async () => {
  return await api.get(resource + 'Folders');
};

export const suggest = async (query) => {
  return await api.get(resource + 'Suggest' + query);
};

// Bir ürünü library resmine bağlar. productid + libraryimageid yeterli.
// Backend, product.image upload'ını silmeden sadece display sırasında
// library URL'ini kullanır; Unlink ile eski upload geri gelir.
export const link = async (body) => {
  return await api.post(resource + 'Link', body);
};

// Library bağlantısını kaldırır; varsa ürünün kendi imagepath'i geri döner.
export const unlink = async (productid) => {
  return await api.post(resource + 'Unlink', { productid });
};

const imageLibraryApi = { list, folders, suggest, link, unlink };

export default imageLibraryApi;
